import { useMemo } from 'react';
import { useCenterType, useCustomFontConfig } from '@app/store';
import { buildFontFaces, hasCenterUrlType, resolveFontFamily } from '@constants/fonts';

// themeConfig inputs for CustomProvider, derived from the store's customFont
// record (the localStorage one until the config API answers, the live one
// after). Returns:
//   - fontFamily: family name applied as --font-family-base; null when the
//                 tenant has no custom font, so the library keeps its default.
//   - fontFaces:  library-shaped [{ family, src, weight, style }] for the
//                 FontFace loader; empty array when there's nothing to load.
// Components that need the raw record read useCustomFontConfig() directly.
//
// Tenant fonts apply only to the SDK/center flows. The EUP dashboard keeps the
// library default, so outside a center flow the record is ignored even if one
// is sitting in the store or localStorage.
const useCustomFont = () => {
  const centerType = useCenterType();
  const storedFont = useCustomFontConfig();
  const isCenterFlow = !!centerType || hasCenterUrlType();
  const customFont = isCenterFlow ? storedFont : null;
  const fontFamily = useMemo(() => resolveFontFamily(customFont), [customFont]);
  const fontFaces = useMemo(() => buildFontFaces(customFont), [customFont]);
  return { fontFamily, fontFaces };
};

export default useCustomFont;
